"use client";

import { useTheme } from "next-themes";
import Image from "next/image";
import { useEffect, useState } from "react";

export function DakaLogo() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Ensure component is mounted before showing theme-dependent content
  useEffect(() => {
    setMounted(true);
  }, []);

  // Show default logo during SSR and initial client render
  if (!mounted) {
    return (
      <Image
        src="https://xnufxmuwqpqsjvrfexko.supabase.co/storage/v1/object/public/assets//daka.png"
        alt="Daka Logo"
        width={100}
        height={100}
      />
    );
  }

  const logoSrc =
    resolvedTheme === "dark"
      ? "/logo/daka_logo_with_text_white.svg"
      : "/logo/daka_logo_with_text_black.svg";

  return (
    <>
      <Image src={logoSrc} alt="Daka Logo" width={100} height={32} />
    </>
  );
}
